// @tennis-matches/services/governance/access-request-notify-admin-api
// Client-API: bei neuer Zugriffsanfrage die Vereinsadmins (owner/admin/vereinsadmin/vorstand)
// des Ziel-Scopes per E-Mail benachrichtigen.
//
// Hinweis: Bewusst NICHT i18n-fähig (Server-Versand-Texte). Wenn später ein
// "Notification-Template-Designer" pro Verein kommt, ersetzt das die Server-Defaults
// in `server.js -> /api/governance/access-requests/notify-admins`.

import { getSupabaseClient } from "../supabase/index.js";

function __asStr(x) {
  return String(x ?? "").trim();
}

async function __authHeaders() {
  const supabase = await getSupabaseClient();
  if (!supabase) return { ok: false, reason: "no-supabase" };
  const { data } = await supabase.auth.getSession();
  const tok = __asStr(data?.session?.access_token);
  if (!tok) return { ok: false, reason: "no-auth" };
  return { ok: true, headers: { Authorization: `Bearer ${tok}`, "Content-Type": "application/json" } };
}

/**
 * Benachrichtigt die Vereinsadmins des Ziel-Scopes über eine neue Zugriffsanfrage.
 *
 * @param {{ requestId: string }} params
 * @returns {Promise<
 *   | { ok: true, mode: string, recipientCount: number, sent: number, adminUrl?: string, skipped?: string }
 *   | { ok: false, reason: string, detail?: unknown }
 * >}
 */
export async function notifyAccessRequestAdminsRemote({ requestId } = {}) {
  const rid = __asStr(requestId);
  if (!rid) return { ok: false, reason: "missing-request-id" };

  const auth = await __authHeaders();
  if (!auth.ok) return auth;

  try {
    const r = await fetch("/api/governance/access-requests/notify-admins", {
      method: "POST",
      headers: auth.headers,
      body: JSON.stringify({ requestId: rid }),
    });
    const j = await r.json().catch(() => null);
    if (!r.ok || !j?.ok) {
      return { ok: false, reason: __asStr(j?.reason || j?.detail || "request-failed"), detail: j?.detail };
    }
    return {
      ok: true,
      mode: __asStr(j.mode) || "mock",
      recipientCount: Number(j.recipientCount) || 0,
      sent: Number(j.sent) || 0,
      adminUrl: __asStr(j.adminUrl) || "",
      skipped: __asStr(j.skipped) || undefined,
    };
  } catch (e) {
    return { ok: false, reason: String(e?.message || e) };
  }
}
